import {defineStore} from 'pinia'
import { jwtDecode } from 'jwt-decode'

export const useUserStore = defineStore('UserStore', {
    state: () => ({
        accessToken: '',
        tokenExpires: 0,
        username: '',
        userId: 0,
        companyId: 0,
        activeCompanyId: 0,
        activeCompanyName: '',
        companyName: '',
        status: 0,
        rights: '',
        productRights: '',
        users: [],
        user: {},
        companies: [],
        auditTrails: [],
        auditTrailsLastTwenty: [],
        userConfiguration: {},
        company: {},
        companyConfiguration: {},
        financialSummary: {},
        clients: [],
        tasks: [],
        prospects: [],
        appointments: [],
        invoices: [],
        payments: [],
        claims: [],
        products: [],
        practitioners: [],
        locations: [],
        billingPlans: [],
        suppliers: [],
        digitalForms: []
    }),
    persist: {
        storage: sessionStorage, // data in sessionStorage is cleared when the page session ends.
    },
    getters: {
        currentuser() {
            return this.username;
        },
        isTokenValid() {
            if (!this.accessToken) {
                return false;
            }
            // Check if the expiration time is in the future.
            // The 'exp' claim is in seconds, so multiply by 1000 for milliseconds.
            return this.tokenExpires * 1000 > Date.now();
        }
    },
    actions: {
        setUserToken(userData) {
            this.username = userData.username;
            this.accessToken = userData.accessToken;
            this.userId = userData.id;
            this.companyId = userData.companyId;
            this.activeCompanyId = userData.companyId;
            this.companies = userData.companies;
            this.status = 1;
            this.rights = userData.right;

            if (userData.accessToken) {
                const decodedToken = jwtDecode(userData.accessToken);
                // The 'exp' claim contains the expiration timestamp in seconds
                this.tokenExpires = decodedToken.exp;
            }
        },
        setUser(userData) {
            this.user = userData;
            this.companyName = userData.companyName;
            this.status = 1;
            this.rights = userData.right;
        },
        setProductRights(productRights) {
            this.productRights = productRights;
        },
        clearUser() {
            this.user = {};
            this.status = 0;
            this.rights = '';
            this.username = '';
            this.companyId = 0;
            this.activeCompanyId = 0;
            this.companies = [];
        },
        setUsers(usersData) {
            this.users = usersData;
        },
        setAuditTrails(auditTrailsData) {
            this.auditTrails = auditTrailsData;
        },
        setUserConfiguration(userConfigurationData) {
            this.userConfiguration = userConfigurationData;
        },
        setCompany(companyData) {
            this.company = companyData;
        },
        setCompanyConfiguration(companyConfigurationData) {
            this.companyConfiguration = companyConfigurationData;
        },
        setFinancialSummary(financialSummaryData) {
            this.financialSummary = financialSummaryData;
        },
        setClients(clientsData) {
            this.clients = clientsData;
        },
        setTasks(tasksData) {
            this.tasks = tasksData;
        },
        setProspects(prospectsData) {
            this.prospects = prospectsData;
        },
        setAppointments(appointmentsData) {
            this.appointments = appointmentsData;
        },
        setInvoices(invoicesData) {
            this.invoices = invoicesData;
        },
        setPayments(paymentsData) {
            this.payments = paymentsData;
        },
        setClaims(claimsData) {
            this.claims = claimsData;
        },
        setProducts(productsData) {
            this.products = productsData;
        },
        setPractitioners(practitionersData) {
            this.practitioners = practitionersData;
        },
        setLocations(locationsData) {
            this.locations = locationsData;
        },
        setBillingPlans(billingPlansData) {
            this.billingPlans = billingPlansData;
        },
        setSuppliers(suppliersData) {
            this.suppliers = suppliersData;
        },
        setDigitalForms(digitalFormData) {
            this.digitalForms = digitalFormData;
        }
    }
})
